import { CHAT_COUNT_DISPLAY_MAX } from '../../../Helpers/Chat/Constant';
import { useLanguage } from '../../../localization/useLanguage';
import { IconArchive, IconChevronLeft } from '../../../Components/Common/Icons';
import styles from './index.module.scss';

/**
 * Header of the archived list, and the only way back to the recent list.
 *
 * The list is opened from the overflow menu, so there is no entry point here.
 *
 * @param count Number of archived conversations.
 * @param onBack Returns to the recent list.
 */
// Same cap the chat list header and the filter chips use, so the counts beside one
// another cannot read differently.
const formatCount = value => (value > CHAT_COUNT_DISPLAY_MAX ? `${CHAT_COUNT_DISPLAY_MAX}+` : value);

export default function ArchivedRow({ count, onBack }) {
    const { t } = useLanguage();

    return (
        <button type="button" className={styles.header} onClick={onBack} aria-label={t('chat.archived.CLOSE')}>
            <span className={styles.back}>
                <IconChevronLeft />
            </span>
            <span className={styles.icon}>
                <IconArchive />
            </span>
            <span className={styles.label}>{t('chat.ARCHIVED_TITLE')}</span>
            <span className={styles.meta}>{formatCount(count)}</span>
        </button>
    );
}
